<h1 class="addons-title">Account Addons</h1>

<div class="addons">

    <mat-card class="addon-card">
        <div class="addon-header">
            <mat-icon class="addon-status-icon" [class.is-active]="hasReathletik()">
                {{hasReathletik() ? 'check_circle' : 'radio_button_unchecked'}}
            </mat-icon>
            <h2 class="addon-name">Reathletik</h2>
            <span class="addon-badge" [class.is-active]="hasReathletik()">
                {{hasReathletik() ? 'Active' : 'Not active'}}
            </span>
        </div>

        <div class="addon-body">
            <div class="addon-row">
                <mat-icon class="addon-row-icon" [class.is-active]="hasMetaKey(this.REATHLETIK_TOKEN)">
                    {{hasMetaKey(this.REATHLETIK_TOKEN) ? 'check_circle' : 'radio_button_unchecked'}}
                </mat-icon>
                <div class="addon-row-text">
                    <div class="addon-row-label">K-Start</div>
                    <small *ngIf="this.getMetaValueDateTimestamp(this.REATHLETIK_ENROLL_DATE) !== undefined"
                           class="addon-row-meta">
                        Requested by customer on {{this.getMetaValueDateTimestamp(this.REATHLETIK_ENROLL_DATE) | date:'medium'}}
                    </small>
                </div>
                <button class="addon-row-action" color="primary" mat-raised-button
                        (click)="this.onProtocolGiveAccess('kstarts')"
                        [disabled]="this.hasMetaKey(this.REATHLETIK_TOKEN)">
                    <mat-icon>add_circle_outline</mat-icon>
                    Add K-Start Protocol
                </button>
            </div>

            <div class="addon-row">
                <mat-icon class="addon-row-icon" [class.is-active]="hasMetaKey(this.REATHLETIK_S_START_TOKEN)">
                    {{hasMetaKey(this.REATHLETIK_S_START_TOKEN) ? 'check_circle' : 'radio_button_unchecked'}}
                </mat-icon>
                <div class="addon-row-text">
                    <div class="addon-row-label">S-Start</div>
                    <small *ngIf="this.getMetaValueDateTimestamp(this.REATHLETIK_S_START_ENROLL_DATE) !== undefined"
                           class="addon-row-meta">
                        Requested by customer on {{this.getMetaValueDateTimestamp(this.REATHLETIK_S_START_ENROLL_DATE) | date:'medium'}}
                    </small>
                </div>
                <button class="addon-row-action" color="primary" mat-raised-button
                        (click)="this.onProtocolGiveAccess('sstarts')"
                        [disabled]="this.hasMetaKey(this.REATHLETIK_S_START_TOKEN)">
                    <mat-icon>add_circle_outline</mat-icon>
                    Add S-Start Protocol
                </button>
            </div>
        </div>
    </mat-card>

    <mat-card class="addon-card">
        <div class="addon-header">
            <mat-icon class="addon-status-icon" [class.is-active]="hasCliniko()">
                {{hasCliniko() ? 'check_circle' : 'radio_button_unchecked'}}
            </mat-icon>
            <h2 class="addon-name">Cliniko</h2>
            <span class="addon-badge" [class.is-active]="hasCliniko()">
                {{hasCliniko() ? 'Active' : 'Not active'}}
            </span>
        </div>

        <div class="addon-body">
            <div class="addon-row">
                <mat-icon class="addon-row-icon" [class.is-active]="hasMetaKey(this.CLINIKO_AUTHORIZED)">
                    {{hasMetaKey(this.CLINIKO_AUTHORIZED) ? 'check_circle' : 'radio_button_unchecked'}}
                </mat-icon>
                <div class="addon-row-text">
                    <div class="addon-row-label">Authorized by the customer</div>
                    <small *ngIf="this.getMetaValueDateTimestamp(this.CLINIKO_AUTHORIZED) !== undefined"
                           class="addon-row-meta">
                        On {{this.getMetaValueDateTimestamp(this.CLINIKO_AUTHORIZED) | date:'medium'}}
                    </small>
                </div>
            </div>

            <div class="addon-row">
                <mat-icon class="addon-row-icon" [class.is-active]="hasMetaKey(this.CLINIKO_KINVENT_AUTHORIZED)">
                    {{hasMetaKey(this.CLINIKO_KINVENT_AUTHORIZED) ? 'check_circle' : 'radio_button_unchecked'}}
                </mat-icon>
                <div class="addon-row-text">
                    <div class="addon-row-label">Authorized by KINVENT</div>
                    <small *ngIf="this.getMetaValueDateTimestamp(this.CLINIKO_KINVENT_AUTHORIZED) !== undefined"
                           class="addon-row-meta">
                        On {{this.getMetaValueDateTimestamp(this.CLINIKO_KINVENT_AUTHORIZED) | date:'medium'}}
                    </small>
                </div>
                <!-- the tooltip sits on the wrapper: Material tooltips do not fire on a disabled button -->
                <span class="addon-row-action"
                      [matTooltip]="!this.hasMetaKey(this.CLINIKO_AUTHORIZED) ? 'The customer must authorize Cliniko first' : 'Give access'">
                    <button color="primary" mat-raised-button
                            (click)="this.onClinikoGiveAccess()"
                            [disabled]="this.hasMetaKey(this.CLINIKO_KINVENT_AUTHORIZED) || !this.hasMetaKey(this.CLINIKO_AUTHORIZED)">
                        <mat-icon>add_circle_outline</mat-icon>
                        Give access
                    </button>
                </span>
            </div>
        </div>
    </mat-card>

    <mat-card class="addon-card">
        <div class="addon-header">
            <mat-icon class="addon-status-icon" [class.is-active]="hasNookal()">
                {{hasNookal() ? 'check_circle' : 'radio_button_unchecked'}}
            </mat-icon>
            <h2 class="addon-name">Nookal</h2>
            <span class="addon-badge" [class.is-active]="hasNookal()">
                {{hasNookal() ? 'Active' : 'Not active'}}
            </span>
        </div>

        <div class="addon-body">
            <div class="addon-row">
                <mat-icon class="addon-row-icon" [class.is-active]="hasMetaKey(this.NOOKAL_AUTHORIZED)">
                    {{hasMetaKey(this.NOOKAL_AUTHORIZED) ? 'check_circle' : 'radio_button_unchecked'}}
                </mat-icon>
                <div class="addon-row-text">
                    <div class="addon-row-label">Connected by the customer</div>
                    <!-- the nookalAuthorized meta holds the access token expiry, not the date of the authorization -->
                    <small *ngIf="this.getMetaValueDateTimestamp(this.NOOKAL_AUTHORIZED) !== undefined"
                           class="addon-row-meta">
                        Access token expires on {{this.getMetaValueDateTimestamp(this.NOOKAL_AUTHORIZED) | date:'medium'}}
                    </small>
                </div>
            </div>

            <div class="addon-row">
                <mat-icon class="addon-row-icon" [class.is-active]="hasMetaKey(this.NOOKAL_KINVENT_AUTHORIZED)">
                    {{hasMetaKey(this.NOOKAL_KINVENT_AUTHORIZED) ? 'check_circle' : 'radio_button_unchecked'}}
                </mat-icon>
                <div class="addon-row-text">
                    <div class="addon-row-label">Approved by KINVENT</div>
                    <small *ngIf="this.getMetaValueDateTimestamp(this.NOOKAL_KINVENT_AUTHORIZED) !== undefined"
                           class="addon-row-meta">
                        On {{this.getMetaValueDateTimestamp(this.NOOKAL_KINVENT_AUTHORIZED) | date:'medium'}}
                    </small>
                </div>
                <!-- the tooltip sits on the wrapper: Material tooltips do not fire on a disabled button -->
                <span class="addon-row-action" [matTooltip]="this.nookalApproveTooltip()">
                    <button color="primary" mat-raised-button
                            (click)="this.onNookalPrepareIntegration()"
                            [disabled]="this.hasMetaKey(this.NOOKAL_KINVENT_AUTHORIZED)
                                || !this.hasMetaKey(this.NOOKAL_AUTHORIZED)
                                || !this.canApproveNookal">
                        <mat-icon>add_circle_outline</mat-icon>
                        Approve &amp; import
                    </button>
                </span>
            </div>
        </div>
    </mat-card>

    <mat-card class="addon-card">
        <div class="addon-header">
            <mat-icon class="addon-status-icon" [class.is-active]="hasModelHealth()">
                {{hasModelHealth() ? 'check_circle' : 'radio_button_unchecked'}}
            </mat-icon>
            <h2 class="addon-name">Model Health</h2>
            <span class="addon-badge" [class.is-active]="hasModelHealth()">
                {{hasModelHealth() ? 'Active' : 'Not active'}}
            </span>
        </div>

        <div class="addon-body">
            <div class="addon-row">
                <mat-icon class="addon-row-icon" [class.is-active]="hasMetaKey(this.MODEL_HEALTH_KINVENT_AUTHORIZED)">
                    {{hasMetaKey(this.MODEL_HEALTH_KINVENT_AUTHORIZED) ? 'check_circle' : 'radio_button_unchecked'}}
                </mat-icon>
                <div class="addon-row-text">
                    <div class="addon-row-label">Authorized by KINVENT</div>
                    <small *ngIf="this.getMetaValueDateTimestamp(this.MODEL_HEALTH_KINVENT_AUTHORIZED) !== undefined"
                           class="addon-row-meta">
                        On {{this.getMetaValueDateTimestamp(this.MODEL_HEALTH_KINVENT_AUTHORIZED) | date:'medium'}}
                    </small>
                </div>
                <button class="addon-row-action" color="primary" mat-raised-button
                        (click)="this.onModelHealthGiveAccess()"
                        [disabled]="this.hasMetaKey(this.MODEL_HEALTH_KINVENT_AUTHORIZED)">
                    <mat-icon>add_circle_outline</mat-icon>
                    Give access
                </button>
            </div>
        </div>
    </mat-card>

    <app-account-api-key-access [accountCode]="this.account.code"></app-account-api-key-access>

</div>
